import React from 'react';
import NOVOLoader from '@/shared/components/NOVOLoader';
import FiltersComponent from '../FiltersComponent';
import MapBoxContainer from '../MyCityMapContainer';

const MyCityDesktopLayout = ({
  mapProps,
  filtersProps,
  markersLoaded,
  loaderStyles,
}) => (
  <div className="flex sm:p-[2.5rem] sm:pt-[2rem] sm:h-fit max-h-[calc(100vh-5rem)] sm:pb-0 p-0">
    <div className="flex flex-col bg-white w-full sm:p-[2rem] p-[1.5rem] sm:rounded-[1rem] rounded-0 gap-[1.5rem] overflow-auto">
      <div
        style={{
          minHeight: 450,
          position: 'relative',
          background: '#eee',
        }}
      >
        {markersLoaded ? (
          <MapBoxContainer {...mapProps} />
        ) : (
          <NOVOLoader style={loaderStyles} />
        )}
      </div>
      <FiltersComponent isMobile={false} {...filtersProps} />
    </div>
  </div>
);

export default MyCityDesktopLayout;
